import { getAPIFullUrl, getAxiosConfig, handleApiError } from './risapi'; // Correct path: ../../../api/risapi
import { risapi } from './risapi'; // Correct path: ../../../api/risapi

export const getPurchaseInvoices = async (filterParameters, callback) => {
    try {
        const response = await risapi.get(getAPIFullUrl('/api/purchase-invoices', filterParameters), getAxiosConfig());
        if (response.status === 200) {
            callback(response.data);
        }
    } catch (error) {
        handleApiError(error); callback({ error });
    }
};

export const fetchPurchaseInvoice = async (id, callback) => {
    try {
        const response = await risapi.get(`/api/purchase-invoices/${id}`, getAxiosConfig());
        if (response.status === 200) {
            callback(response.data);
        }
    } catch (error) {
        handleApiError(error); callback({ error });
    }
};

export const createPurchaseInvoice = async (newData, callback) => {
    try {
        // Complex data with nested arrays, send as JSON
        const response = await risapi.post('/api/purchase-invoices', newData, getAxiosConfig());
        if (response.status === 201) {
            callback(response.data);
        }
    } catch (error) {
        callback(error); // Let form handle validation errors
    }
};

export const updatePurchaseInvoice = async (editData, callback) => {
    try {
        // Complex data with nested arrays, send as JSON
        const response = await risapi.put(`/api/purchase-invoices/${editData.id}`, editData, getAxiosConfig());
        if (response.status === 200) {
            callback(response.data);
        }
    } catch (error) {
        callback(error); // Let form handle validation errors
    }
};

export const destroyPurchaseInvoice = async (itemToDelete, callback) => {
    try {
        const response = await risapi.delete(`/api/purchase-invoices/${itemToDelete.id}`, getAxiosConfig());
        if (response.status === 204) {
            callback({ purchase_invoice: itemToDelete }); // Success
        }
    } catch (error) {
        callback({ error }); // Let list page handle conflict/error
    }
};

// --- Add destroyPurchaseInvoicesMultiple later ---